import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bookmark, BookmarkCheck } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { useSavedJobs } from "@/lib/useSavedJobs";

export const SaveJobButton = ({ job, variant = "icon", testId }) => {
  const { user, login } = useAuth();
  const { byJobId, save, remove } = useSavedJobs();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const saved = byJobId[job.id];

  const onClick = async () => {
    if (!user) {
      toast("Sign in to save jobs and track your applications.", { action: { label: "Sign in", onClick: () => login({ reason: "Sign in to save roles and track your applications." }) }, id: "save-sign-in" });
      return;
    }
    setBusy(true);
    try {
      if (saved) {
        await remove(saved.id);
        toast(`Removed ${job.title} from My Jobs.`);
      } else {
        await save(job);
        toast.success(`Saved ${job.title}.`, { action: { label: "Open My Jobs", onClick: () => navigate("/my-jobs") } });
      }
    } catch (error) {
      toast.error(error.message || "Could not update your saved jobs.");
    } finally {
      setBusy(false);
    }
  };

  const Icon = saved ? BookmarkCheck : Bookmark;
  const label = saved ? "Saved" : "Save";
  const base = saved ? "border-[#0FBF77] bg-[#F0FBF6] text-[#0A8F5A]" : "border-[#D2D5DA] bg-white text-[#3C4450] hover:border-[#0F141B] hover:text-[#0F141B]";
  if (variant === "icon") {
    return <button type="button" data-testid={testId} aria-pressed={Boolean(saved)} aria-label={saved ? `Remove ${job.title} from My Jobs` : `Save ${job.title} to My Jobs`} title={label} disabled={busy} onClick={onClick} className={`inline-flex items-center justify-center w-10 h-full min-h-[2.5rem] lg:w-full lg:h-auto lg:py-2.5 border transition-colors disabled:opacity-60 ${base}`}><Icon size={14} aria-hidden="true" fill={saved ? "currentColor" : "none"} /></button>;
  }
  return <button type="button" data-testid={testId} aria-pressed={Boolean(saved)} disabled={busy} onClick={onClick} className={`inline-flex items-center gap-2 px-4 py-3 border font-mono-label text-[10px] !tracking-normal transition-colors disabled:opacity-60 ${base}`}><Icon size={13} aria-hidden="true" fill={saved ? "currentColor" : "none"} />{saved ? "Saved to My Jobs" : "Save to My Jobs"}</button>;
};
